
import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const Administration = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>School Administration</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>School</li>
                    <li>|</li>
                    <li>School Administration</li>
                </ul>
            </div>
            <div className="inner_page">
                <div className="container">
                    <div className="row">

                        <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12">
                            <div className="principal-blk">
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal_1.jpg" alt="St Francis School, Amritsar" /></LazyLoad>
                                <h3>REV. FR. FINBAR OFM CAP</h3>
                                <p>(1953 – 1961)</p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12">
                            <div className="principal-blk">
                                <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal_2.jpg" alt="St Francis School, Amritsar" /></LazyLoad>
                                <h3>REV. FR. TIMOTHY</h3>
                                <p>(1961 – 1982)</p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12">
                            <div className="principal-blk">
                                <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal_3.jpg" alt="St Francis School, Amritsar" /></LazyLoad>
                                <h3>REV. FR. JOSE PUTHENPURA</h3>
                                <p>(1982 – 1993)</p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12">
                            <div className="principal-blk">
                                <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal_4.jpg" alt="St Francis School, Amritsar" /></LazyLoad>
                                <h3>REV. FR. K.V JOSEPH</h3>
                                <p>(1993 – 1995)</p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12">
                            <div className="principal-blk">
                                <LazyLoad>   <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal_5.jpg" alt="St Francis School, Amritsar" /></LazyLoad>
                                <h3>REV. FR. JOSE T.</h3>
                                <p>(1995 – 2002)</p>

                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12">
                            <div className="principal-blk">
                                <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal_6.jpg" alt="St Francis School, Amritsar" /></LazyLoad>
                                <h3>REV. SR. JOSSY</h3>
                                <p>(2002 – 2008)</p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12">
                            <div className="principal-blk">
                                <LazyLoad> <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal_7.jpg" alt="St Francis School, Amritsar" /></LazyLoad>
                                <h3>REV. SR. RITA</h3>
                                <p>(2008 – 2011)</p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12">
                            <div className="principal-blk">
                                <LazyLoad> <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal_8.jpg" alt="St Francis School, Amritsar" /></LazyLoad>
                                <h3>REV. SR. MARIA</h3>
                                <p>(2011 – 2013)</p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12">
                            <div className="principal-blk">
                                <LazyLoad> <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal_9.jpg" alt="St Francis School, Amritsar" /></LazyLoad>
                                <h3>REV. FR. JOHN EDIYAKUNNEL</h3>
                                <p>(2013 - 2015)</p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12">
                            <div className="principal-blk">
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal_10.jpg" alt="St Francis School, Amritsar" /></LazyLoad>
                                <h3>SR. TERESA FSMA</h3>
                                <p>(2015 - 2018)</p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12">
                            <div className="principal-blk">
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal_11.png" alt="St Francis School, Amritsar" /></LazyLoad>
                                <h3>  SR. PRIYA</h3>
                                <p>(2019 - 2024)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Administration
